import React, { useState } from 'react';
import { useMutation } from "@apollo/client/react";
import { DialogActions } from '@/components/widgets/DialogActions';
import { DialogContent } from '@/components/widgets/DialogContent';
import { DialogTitle } from '@/components/widgets/DialogTitle';
import Button from '@/lib/vendor/@material-ui/core/src/Button';
import { gql } from "@/lib/generated/gql-codegen";
import moment from 'moment';
import LWDialog from "../../common/LWDialog";
import { DatePicker } from "../../form-components/FormComponentDateTime";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('LockThreadDialog', (theme: ThemeType) => ({
  message: {
  },
}));

const LockThreadDialog = ({commentId, onClose}: {
  commentId: string,
  onClose: () => void,
}) => {
  const classes = useStyles(styles);
  const farFuture: Date = moment().add(1000,'years').toDate();
  const [until,setUntil] = useState<Date>(farFuture);

  const [lockThread] = useMutation(gql(`
    mutation lockThread($commentId: String!, $until: String) {
      lockThread(commentId: $commentId, until: $until)
    }
  `));
  const handleLockThread = async () => {
    await lockThread({
      variables: {
        commentId,
        until: until.toISOString(),
      }
    });
    onClose();

    // HACK: The cient-side cache doesn't update to reflect this change, so
    // hard-refresh the page
    window.location.reload();
  }
  return (
    <LWDialog open={true} onClose={onClose}>
      <DialogTitle>Lock Comment Thread</DialogTitle>
      <DialogContent>
        <p className={classes.message}>
          Prevent replies to this comment and all comments descended from it
        </p>

        <DatePicker
          label="Locked until"
          name="lockUntil"
          value={until ?? undefined}
          onChange={(newValue: Date) => setUntil(newValue)}
        />

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleLockThread}>Confirm</Button>
      </DialogActions>
    </LWDialog>
  );
}

export default LockThreadDialog;


